// React
import { useState } from "react";
// Recoil
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import {
  activeTable,
  popupState,
  resListData,
  tableOrderList,
} from "../../atom/pos";

type PropsTypes = {
  type: string;
};
function PosPopupPay(props: PropsTypes) {
  // 포스 결제 팝업

  // Recoil State
  const resetPopupState = useResetRecoilState(popupState);
  const resetTable = useResetRecoilState(activeTable);
  const tableNum = useRecoilValue(activeTable);
  const [orderListData, setOrderListData] = useRecoilState(tableOrderList);

  // Function
  const resetOrder = () => {
    const prevOrderList = [...orderListData];
    prevOrderList.splice(tableNum - 1, 1, {
      num: tableNum,
      time: "",
      menu: [],
    });
    setOrderListData(prevOrderList);
    resetPopupState();
    resetTable();
  };

  const calcTotalAmount = () => {
    let amt = 0 as number;
    orderListData[tableNum - 1].menu.reduce((acc, cur) => {
      amt = acc + cur.price * cur.ea;
      return amt;
    }, amt);
    return amt.toLocaleString();
  };

  return (
    <div className="pos-popup-bg">
      <div className="pos-popup-wrap">
        <div className="popup-head">
          <div>{props.type === "cash" ? "현금결제" : "신용카드"}</div>
          <div className="table-info-box" style={{ margin: "8px 0" }}>
            <span>테이블 {tableNum < 10 ? "0" + tableNum : tableNum}</span>
          </div>
          <div
            className="close-box"
            onClick={() => {
              resetPopupState();
            }}
          >
            <img
              className="icon"
              src={"/assets/images/pos/close.svg"}
              alt="reauest"
              width={"100%"}
              height={"100%"}
            />
          </div>
        </div>
        <div className="popup-body-pos">
          <div className="popup-title">
            {props.type === "cash" ? "현금결제" : "결제정보"}
          </div>
          <div className="body-wrap">
            {props.type === "cash" ? (
              <div className="body-left">
                <div className="popup-row">
                  <div className="popup-subtitle">받을금액</div>
                  <div className="popup-subtitle">받은금액</div>
                  <div className="popup-subtitle">거스름돈</div>
                </div>
                <div className="popup-row" style={{ marginTop: "0.3rem" }}>
                  <input
                    className="popup-input"
                    type="text"
                    value={calcTotalAmount()}
                  />
                  <input className="popup-input" type="number" />
                  <input className="popup-input" type="number" />
                </div>
                <div className="popup-row" style={{ marginTop: "0.8rem" }}>
                  <div className="popup-btn1">천원</div>
                  <div className="popup-btn1">오천원</div>
                  <div className="popup-btn1">만원</div>
                  <div className="popup-btn1">오만원</div>
                  <div className="popup-btn1">십만원</div>
                </div>
                <div className="popup-title" style={{ marginTop: "1.1rem" }}>
                  현금영수증
                </div>
                <div className="popup-row">
                  <div className="popup-subtitle">식별번호</div>
                </div>
                <div className="popup-row" style={{ marginTop: "0.3rem" }}>
                  <input className="popup-input" type="number" />
                  <div className="popup-btn1" style={{ width: "50%" }}>
                    번호입력
                  </div>
                  <div className="popup-btn2" style={{ width: "75%" }}>
                    현금영수증 승인
                  </div>
                  <div className="popup-btn2" style={{ width: "75%" }}>
                    현금영수증 카드 승인
                  </div>
                </div>
                <div className="popup-row">
                  <div className="popup-radio-wrap">
                    <img
                      className="icon"
                      src={"/assets/images/pos/check_box.svg"}
                      alt="check"
                      height={"100%"}
                    />
                    <div className="popup-radio-text">소득공제용 (개인)</div>
                  </div>
                  <div className="popup-radio-wrap">
                    <img
                      className="icon"
                      src={"/assets/images/pos/check_box_false.svg"}
                      alt="check"
                      height={"100%"}
                    />
                    <div className="popup-radio-text">지출증빙용 (사업자)</div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="body-left">
                <div className="popup-row">
                  <div className="popup-subtitle" style={{ width: "30%" }}>
                    결제대상금액
                  </div>
                  <div className="popup-subtitle" style={{ width: "50%" }}>
                    카드정보
                  </div>
                  <div className="popup-subtitle" style={{ width: "20%" }}>
                    할부
                  </div>
                </div>
                <div className="popup-row" style={{ marginTop: "0.3rem" }}>
                  <input
                    className="popup-input"
                    type="text"
                    style={{ width: "30%" }}
                    value={calcTotalAmount()}
                  />
                  <input
                    className="popup-input"
                    type="number"
                    style={{ width: "50%" }}
                  />
                  <input
                    className="popup-input"
                    type="number"
                    style={{ width: "20%" }}
                  />
                </div>
                <div className="popup-title" style={{ marginTop: "1.1rem" }}>
                  기타카드
                </div>
                <div className="popup-row">
                  <div className="popup-subtitle">식별번호</div>
                </div>
                <div className="popup-row" style={{ marginTop: "0.3rem" }}>
                  <div className="popup-btn2">임의등록</div>
                  <div className="popup-btn1">유니온페이</div>
                  <div className="popup-btn1">현금 IC카드</div>
                </div>
              </div>
            )}
            <div className="body-right">
              <div
                className="popup-btn3 pointer"
                style={{ marginTop: "1.8rem" }}
                onClick={() => {
                  // resetPopupState();
                  resetOrder();
                }}
              >
                {props.type === "cash" ? "단순현금결제" : "승인요청"}
              </div>
              <div
                className="calc-wrap"
                style={{ marginTop: "1.375rem", height: "65%" }}
              >
                <div className="calc-body">
                  <div className="calc-row" style={{ height: 70 }}>
                    <div className="calc-btn roboto">7</div>
                    <div className="calc-btn roboto">8</div>
                    <div className="calc-btn roboto">9</div>
                  </div>
                  <div className="calc-row" style={{ height: 70 }}>
                    <div className="calc-btn roboto">4</div>
                    <div className="calc-btn roboto">5</div>
                    <div className="calc-btn roboto">6</div>
                  </div>
                  <div className="calc-row" style={{ height: 70 }}>
                    <div className="calc-btn roboto">1</div>
                    <div className="calc-btn roboto">2</div>
                    <div className="calc-btn roboto">3</div>
                  </div>
                  <div className="calc-row" style={{ height: 70 }}>
                    <div className="calc-btn roboto">
                      <img
                        className="icon"
                        src={"/assets/images/pos/back.svg"}
                        alt="reauest"
                        width={"40px"}
                        height={"40px"}
                      />
                    </div>
                    <div className="calc-btn roboto">0</div>
                    <div className="calc-btn roboto">CLR</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="message-wrap" style={{ marginTop: "auto" }}>
            <span className="roboto">Message.</span>
            <input
              className="popup-input"
              type="number"
              style={{ marginTop: "0.6rem" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
function PosPopupRes() {
  // 포스 예약 팝업

  // Recoil State
  const resetPopupState = useResetRecoilState(popupState);
  const [resList, setResList] = useRecoilState(resListData);
  // useState
  const resTitle = [
    "상태",
    "예약자명",
    "전화번호",
    "예약번호",
    "이용일자",
    "인원",
    "신청일자",
    "예약경로",
    "요청사항",
    "상세보기",
  ];
  const [selected, setSelected] = useState<number>(0);
  const [completePopup, setCompletePopup] = useState<boolean>(false);

  return (
    <div className="pos-popup-bg">
      <div className="pos-popup-wrap">
        <div className="popup-head">
          <div>예약</div>
          <div
            className="close-box"
            onClick={() => {
              resetPopupState();
            }}
          >
            <img
              className="icon"
              src={"/assets/images/pos/close.svg"}
              alt="reauest"
              width={"100%"}
              height={"100%"}
            />
          </div>
        </div>
        <div className="popup-body-res">
          <div className="body-wrap">
            <div
              className="popup-row"
              style={{ gap: 0, alignItems: "center", maxHeight: 45 }}
            >
              <div
                className="popup-subtitle"
                style={{ maxWidth: "fit-content", marginRight: "0.5rem" }}
              >
                기간조회
              </div>
              <div
                className="find-input"
                style={{
                  width: "50%",
                  justifyContent: "left",
                  paddingLeft: "0.5rem",
                  borderRight: "none",
                }}
              >
                이용일
              </div>
              <div
                className="find-input"
                style={{
                  width: "20%",
                  marginRight: "0.5rem",
                  aspectRatio: "1/1",
                }}
              >
                <img
                  src={"/assets/images/pos/arrow_down.svg"}
                  alt=""
                  width={"26px"}
                  height={"26px"}
                />
              </div>
              <div
                className="find-input"
                style={{ width: "80%", borderRight: "none" }}
              >
                2022-10-06
              </div>
              <div
                className="find-input"
                style={{
                  width: "20%",
                  marginRight: "0.3rem",
                  aspectRatio: "1/1",
                }}
              >
                <img
                  src={"/assets/images/pos/calender.svg"}
                  alt=""
                  width={"26px"}
                  height={"26px"}
                />
              </div>
              ~
              <div
                className="find-input"
                style={{
                  width: "80%",
                  marginLeft: "0.3rem",
                  borderRight: "none",
                }}
              >
                2022-10-06
              </div>
              <div
                className="find-input"
                style={{
                  width: "20%",
                  marginRight: "2rem",
                  aspectRatio: "1/1",
                }}
              >
                <img
                  src={"/assets/images/pos/calender.svg"}
                  alt=""
                  width={"26px"}
                  height={"26px"}
                />
              </div>
              <div
                className="popup-subtitle"
                style={{ maxWidth: "fit-content", marginRight: "0.5rem" }}
              >
                검색어
              </div>
              <div
                className="find-input"
                style={{
                  width: "50%",
                  justifyContent: "left",
                  paddingLeft: "0.5rem",
                  borderRight: "none",
                }}
              >
                예약자명
              </div>
              <div
                className="find-input"
                style={{
                  width: "20%",
                  aspectRatio: "1/1",
                  marginRight: "0.3rem",
                }}
              >
                <img
                  src={"/assets/images/pos/arrow_down.svg"}
                  alt=""
                  width={"26px"}
                  height={"26px"}
                />
              </div>
              <div
                className="find-input"
                style={{ width: "60%", marginRight: "0.3rem" }}
              >
                {" "}
              </div>
              <div
                className="action-btn confirm"
                style={{ width: "50%", height: "100%" }}
              >
                조회
              </div>
            </div>
            <div className="popup-row" style={{ gap: 0 }}>
              <div className="filter-btn seleted">전체</div>
              <div
                className="filter-btn"
                style={{ borderLeft: 0, color: "#FF6B00" }}
              >
                예약확정
              </div>
              <div
                className="filter-btn"
                style={{ borderLeft: 0, color: "#654CE3" }}
              >
                요청
              </div>
              <div className="filter-btn" style={{ borderLeft: 0 }}>
                완료
              </div>
              <div className="filter-btn" style={{ borderLeft: 0 }}>
                취소
              </div>
              <div className="filter-btn" style={{ borderLeft: 0 }}>
                노쇼
              </div>
              <div className="online-btn" style={{ borderLeft: 0 }}>
                <img
                  src={"/assets/images/pos/shape.svg"}
                  alt=""
                  width={"24px"}
                  height={"24px"}
                />
                <span>온라인예약받기</span>
              </div>
            </div>
            <div className="list-border">
              <div className="res-list-row">
                {resTitle.map((v) => (
                  <div>{v}</div>
                ))}
              </div>
              <div className="res-list-wrap">
                <>
                  {resList.map((v, i) =>
                    i === selected ? (
                      <div
                        className="res-list selected"
                        onClick={() => {
                          setSelected(i);
                        }}
                      >
                        <ResChips type={v.state} />
                        <div>{v.name}</div>
                        <div>{v.phone}</div>
                        <div>{v.resnum}</div>
                        <div>{v.date}</div>
                        <div>{v.people}</div>
                        <div>{v.resdate}</div>
                        <div>{v.resway}</div>
                        <div>{v.req === "-" ? v.req : "있음"}</div>
                        <div>
                          <div
                            className="filter-btn"
                            style={{
                              width: "calc(100% - 0.6rem)",
                              backgroundColor: "white",
                            }}
                          >
                            {v.detail ? "자세히" : "상세"}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="res-list"
                        onClick={() => {
                          setSelected(i);
                        }}
                      >
                        <ResChips type={v.state} />
                        <div>{v.name}</div>
                        <div>{v.phone}</div>
                        <div>{v.resnum}</div>
                        <div>{v.date}</div>
                        <div>{v.people}</div>
                        <div>{v.resdate}</div>
                        <div>{v.resway}</div>
                        <div>{v.req === "-" ? v.req : "있음"}</div>
                        <div>
                          <div
                            className="filter-btn"
                            style={{
                              width: "calc(100% - 0.6rem)",
                              backgroundColor: "white",
                            }}
                          >
                            {v.detail ? "자세히" : "상세"}
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </>
              </div>
            </div>
            <div className="popup-row">
              <div
                className="action-btn confirm"
                onClick={() => {
                  setCompletePopup(true);
                }}
              >
                예약확정
              </div>
              <div className="action-btn cancel">취소</div>
              <div className="action-btn noshow">노쇼</div>
              <div className="action-btn complete">이용완료</div>
              <div className="res-add-btn">예약등록</div>
            </div>
          </div>
          <div className="message-wrap">
            <span className="roboto">Message.</span>
            <input
              className="popup-input"
              type="number"
              style={{ marginTop: "0.6rem" }}
            />
          </div>
        </div>
      </div>
      {completePopup && (
        <ResPopup setCompletePopup={setCompletePopup} selected={selected} />
      )}
    </div>
  );
}

function ResChips(props: PropsTypes) {
  // 예약 칩스
  return props.type === "확정" ? (
    <div>
      <div className="res-state-chips orange">{props.type}</div>
    </div>
  ) : props.type === "요청" ||
    props.type === "변경요청" ||
    props.type === "취소요청" ? (
    <div>
      <div className="res-state-chips purple">{props.type}</div>
    </div>
  ) : (
    <div>
      <div className="res-state-chips">{props.type}</div>
    </div>
  );
}

interface Props {
  setCompletePopup: React.Dispatch<React.SetStateAction<boolean>>;
  selected: number;
}
function ResPopup(props: Props) {
  // 예약 확정 팝업
  // 고정 텍스트

  // Recoil State
  const [resList, setResList] = useRecoilState(resListData);
  // useState
  const [inputData, setInputData] = useState<string>(
    "예약이 확정되었습니다. 꼭 지정된 시간에 입장 부탁드립니다."
  );

  // Function
  const setCompleteReserve = (type: string) => {
    if (type === "complete") {
      const prevRes = [...resList];
      prevRes.splice(props.selected, 1, {
        ...prevRes[props.selected],
        state: "확정",
      });
      setResList(prevRes);
    }
    props.setCompletePopup(false);
  };
  return (
    <div className="res-popup-wrap">
      <div className="popup-head">
        <div>예약확정</div>
        <div
          className="close-box"
          onClick={() => {
            setCompleteReserve("close");
          }}
        >
          <img
            className="icon"
            src={"/assets/images/pos/close.svg"}
            alt="reauest"
            width={"100%"}
            height={"100%"}
          />
        </div>
      </div>
      <div className="res-popup-body">
        <div className="res-popup-text-box">
          선택된 예약 건을 확정합니다. <br />
          확정 안내사항이 있는 경우, <br />
          안내메세지를 작성해주세요.
        </div>
        <div className="res-row">
          <span>예약 확정 안내</span>
          <span>
            <strong>46자</strong>/200자
          </span>
        </div>
        <textarea
          className="res-input-box"
          rows={8}
          value={inputData}
          onChange={(e) => {
            setInputData(e.target.value);
          }}
        ></textarea>
        <div
          className="res-btn"
          onClick={() => {
            setCompleteReserve("complete");
          }}
        >
          예약확정
        </div>
      </div>
    </div>
  );
}

export { PosPopupPay, PosPopupRes, ResPopup };
